import last from 'lodash/last';
import 'url-polyfill';

export function getUrlExtension(url: string): string {
  const pathname = url
    .split('#')[0]
    .split('?')[0]
    .replace(/http[s]:\/\//, '');
  if (pathname.indexOf('/') === -1) {
    throw new Error(`There is no extension in URL "${url}"`);
  }
  const lastComp = last(pathname.split('/')) ?? '';
  const ext = last(lastComp.split('.')) ?? '';
  return ext.toLowerCase();
}

export function getPageSearchParam(paramName: string): string | null {
  return new URL(document.location.toString()).searchParams.get(paramName);
}

export function forceHttpsUrl(url: string): string {
  // noinspection HttpUrlsUsage
  if (url.startsWith('http://')) {
    // noinspection HttpUrlsUsage
    return url.replace('http://', 'https://');
  } else if (url.startsWith('https://')) {
    return url;
  } else {
    throw new Error(`Invalid URL: ${url}`);
  }
}
